import * as React from 'react';

import TextField from '@material-ui/core/TextField';
import DialogContentText from '@material-ui/core/DialogContentText';

interface Props {
  value: number | string;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
  error: boolean;
  title: string;
  placeholder: string;
  errorMessage: string;
  disabled: boolean;
}

function SubInput (props: Props) {
  
  const {
    value,
    onChange,
    error,
    title,
    placeholder,
    errorMessage,
    disabled,
  } = props;

  return(
    <div className='sub-input-wrapper'>
      <br />
      <DialogContentText>
        {title}
      </DialogContentText>
      <TextField
        disabled={disabled}
        placeholder={placeholder}
        error={error}
        label=''
        value={value}
        // @ts-ignore
        onChange={onChange}
        id='outlined-basic'
        variant='outlined' />
      {error
        ? (
          <p className='color-red'>
            {errorMessage}
          </p>
        ) : null }
    </div>
  );
}

export default React.memo(SubInput);
